var app = require('../index');
var deepCopy = require('../../util/deepCopy');

var SongList = require('../../data-objects/SongList'),
	StaticSongList = require('../../data-objects/SongList/StaticSongList'),
	DynamicSongList = require('../../data-objects/SongList/DynamicSongList');

//API key for ShareThis.com
var shareThisApiKey = 'a4ece9c8f003917c803a395149181895';
	
//Song List buttons

app.fn('songLists.createFromSelection', function(e, el) {
	var model = this.model;

	if ($('.song-checkbox:checked').length==0) {
		alert('Please select at least one song');
		return;
	}

	//If all songs on this page are selected and there is more than one page of results
	if ($('#selectAllCheckbox').prop('checked') && model.get('_page.paginator.totalPages') > 1) {
		//Ask whether to add the songs just for this page or for all pages
		$('#createListFromSelectionConfirmationTrigger').popover('show');
		$('#createListFromSelectionConfirmationClose').click(function() {
			$('#createListFromSelectionConfirmationTrigger').popover('hide');
		})
	}
	else createSongListFromSelection();
});

//This is where we really show the "Add Songs to Song List" form...
//in the above method we might have needed to confirm the user's intent
//if all songs were selected
app.fn('songLists.createFromSelectionConfirmed', createSongListFromSelection);

function createSongListFromSelection() {
	$('#createListFromSelectionConfirmationTrigger').popover('hide');

	var model = app.model;
	//it's only possible to create dynamic lists from a selection if all search results are selected
	//and there's only one page of results
	if ($('#selectAllCheckbox').prop('checked') && model.get('_page.paginator.totalPages')==1) {
		model.set('_page.songListForm.dynamicListAllowed', true);
		model.set('_page.songListForm.createDynamicList', true);
	}
	else {
		model.set('_page.songListForm.dynamicListAllowed', false);
		model.set('_page.songListForm.createDynamicList', false);
	}

	$('#addToSongListForm').modal('show');

	$('#addToSongListForm').find('.close').click(function() {
		$('#addToSongListForm').modal('hide');
	});
}

app.fn('songLists.createFromSearch', createSongListFromSearch);
function createSongListFromSearch() {
	$('#createListFromSelectionConfirmationTrigger').popover('hide');

	var model = this.model;
	model.set('_page.songListForm.dynamicListAllowed', true);
	model.set('_page.songListForm.createDynamicList', true);
	$('#addToSongListForm').modal('show');
}

app.fn('songLists.addFromSongDetailPage', function(e, el) {
	var model = this.model;
	//dynamic lists are saved searches, so it's not possible to add an individual song to them
	model.set('_page.songListForm.dynamicListAllowed', false);
	model.set('_page.songListForm.createDynamicList', false);
	$('#addToSongListForm').modal('show');
});

//This is where we actually create or update the song list and save it;
//it's triggered by the submit button on the "add to song list" popup
app.fn('songLists.createOrUpdate', function(e, el) {
	//TODO
	//If adding to an existing list, notify user if the song(s) they're adding are already in the song list

	var model = this.model;
	var listName = e.get('.listName');

	var list;
	var songListFormModel = model.at('_page.songListForm');
	var userIsSubscriber = model.get('_session.user.isSubscribed');
	var isDynamic = songListFormModel.get('dynamicListAllowed') && songListFormModel.get('createDynamicList');

	//if the user chose an existing song list
	if (songListFormModel.get('existingSongList')) {
		var selectedListId = songListFormModel.get('selectedListId');
		if (!selectedListId) {
			alert('Please either select a song list, or select "Create a new song list"');
			return;
		}

		var listJson;
		var specialSharedSongListCondition = false;
		if (determineSongListSaveType(model) == 'db') {
			listJson = model.get('songLists.' + selectedListId);
			//It might be an editable list that was shared with the current user, but which wasn't created
			//by the current user.
			if (listJson.userId != model.get('_session.userId')) {
				specialSharedSongListCondition = true;
			}
		}
		else {
			listJson = model.get('_session.songLists.' + selectedListId);
			//It might be an editable list that was shared with the current user, in which case it's stored
			//in the DB even though the rest of the current user's lists are stored in the session.
			if (!listJson) {
				specialSharedSongListCondition = true;
				listJson = model.get('songLists.' + selectedListId);
			}
		}
		
		if (!listJson) {
			alert('Error retrieving song list');
			return;
		}
		
		//restore SongList object
        list = SongList.fromJson(listJson);

        if (list instanceof DynamicSongList) {
            //TODO is there a more elegant solution for this?
            var msg = 'The list you selected is an auto-updating song list based on search parameters rather than individual songs. ' +
                'If you continue, this list will be replaced with your current search criteria or selection. Click OK to continue.';
            if (!confirm(msg)) return;

            //if necessary, convert to static song list
            if (! songListFormModel.get('createDynamicList')) {
                list = new StaticSongList(list.name);
                list.id = selectedListId;
            }
        }
	}
	//New song list
	else {
		if (!validateSongListName(listName)) return;

		//Dynamic list - based on search parameters
		if (isDynamic) {
			list = new DynamicSongList(listName);
		}
		//Static list - list of specific song IDs
		else {
			list = new StaticSongList(listName);
		}
	}

	var listJson;
	if (isDynamic) {
		list.searchParams = model.get('_page.search');
		list.queryParams = model.get('_page.queryParams');
		listJson = list.toJson();
	}
	else {
		//If we're adding a song from the song detail page, it's a simple case - just add that song
		if (model.get('_page.isSongDetailPage')) {
			list.addSong( model.get('_page.song.id') );
			listJson = list.toJson();
		}
		//Otherwise we're adding from the search results page...
		else {
			var $checkedCheckboxes = $('.song-checkbox:checked');
			//Usually with a static list, some of the checkboxes will have been checked...
			if ($checkedCheckboxes.length) {
				var selectedSongIds = $checkedCheckboxes.map(function() {
					return $(this).val();
				})
				.get();
				list.addSongIds(selectedSongIds);
				listJson = list.toJson();
			}
			//...but it's also possible for a static list to be created from a search as a whole,
			//in which case we need to retrieve all the song IDs that match this search.
			//The server takes care of this since Derby doesn't currently support MongoDB projections
			else {
				listJson = list.toJson();
				listJson.queryParams = JSON.stringify(model.get('_page.queryParams'));
			}
		}
	}
	
	saveSongList(listJson, function() {
		//special case:
		if (specialSharedSongListCondition) {
			//In this case the song list doesn't appear in the user's account because it's not their own song list
			//(or maybe it was in a previous anonymous session, but we have no way of knowing that now).
			//So redirect directly to the list they just updated.
			window.location = '/song-lists/' + listJson.id;
			return;
		}
	
		//For institutional users not logged into an individual account, redirect immediately to the song lists page
		//so they can save their list.
		if (model.get('_session.institutionalPlanType') == 'singleLimitedAccount') {
			window.location = '/song-lists';
			return;
		}
	
		alert('Song list saved successfully. Click "My Song List" to access it.');
		$('#addToSongListForm').modal('hide');

		//TEMP
		//The list of song lists needs to be updated since it wasn't called using subscribe()
		//(and for free users subscribe() wouldn't work anyway b/c lists aren't stored in DB)
		window.location.reload();
	});

	//model.add('songLists', list);
});

app._saveSongList = function saveSongList(listJson, callback) {
	if (!callback) callback = function() { alert('Song list saved successfully') };
	
	var model = app.model;
	//Check to see whether the list will be saved to the session or to the DB.
	//First, check for the special case of an editable list that was shared with the current user.
	//If so, then it should be saved to the DB even if the rest of the current user's lists should be saved to the session.
	var promise;
	if (listJson.id) {
		promise = app._getSongListsWithStorageLocation().then(function(lists) {
			//find the matching list
			var matchingList = lists[listJson.id];
			if (matchingList) {
				return matchingList._storageLocation;
			}
			else return determineSongListSaveType(model);
		});
	}
	else promise = Promise.resolve(determineSongListSaveType(model));
	
	promise.then(function(storageLocation) {
		//log('storageLocation', storageLocation)
	
		if (storageLocation == 'session') {
			//use the list name as the ID
			listJson.id = listJson.name;
			
			//Workaround for Firefox - save song lists to cookie in addition to session
			//(issue with sessions over HTTPS)
			if (navigator.userAgent.indexOf('Firefox') != -1) {
				saveSongListToCookie(listJson);
			}
		}
		
		//We use AJAX to save the song list on the server for 2 reasons:
		//1. Free users don't have accounts, so we save their lists to the session instead of database
		//2. If the user chooses to add multiple pages of search results but NOT have the list auto-update,
		//   we need to query the DB for just the IDs of the matching songs, which is more efficient to do on the server
		//   (since Derby's model doesn't support projections)
		$.post('/save-song-list',
			{
				listJson: JSON.stringify(listJson),
				storageLocation: storageLocation,
				editCode: model.get('_page.editCode')
			},
			null, 'json'
		)
		.done(function(success) {
			if (success === true) {
				//if a session-stored list was renamed, delete the old song list
				var oldName = model.get('_page.origSongList.name');
				if (storageLocation == 'session' && oldName && oldName != listJson.name) {
					deleteSongList(oldName, callback);
				}
				else callback();
			}
			else showError();
		})
		.error(showError);
	
		function showError() {
			alert('There was an error saving your song list. Please try again, or contact us if the error persists.');
		}
	});
};
var saveSongList = app._saveSongList;

/*
 * async function (returns promise)
 *
 * The song lists returned by this function are used to populate the drop-down list of song lists
 * that appears when adding additional song(s) to an existing song list.
 *
 * This gets all the song lists for the current user (either from the session or DB as appropriate)
 * and ALSO any additional editable song lists shared with the current user that have been opened
 * so far this session. It also adds a temporary _storageLocation property to every list.
 */
app._getSongListsWithStorageLocation = function(asArray) {
	var model = app.model;
	var currentStorageLocation = determineSongListSaveType(model);
	var songLists;
	if (currentStorageLocation == 'session') {
		//firefox workaround
		if (navigator.userAgent.indexOf('Firefox') != -1) {
			songLists = localStorage.getItem('songLists');
			songLists = (songLists ? $.parseJSON(songLists): {});
			model.set('_session.songLists', songLists);
			//log('songLists', songLists)
		}
		songLists = Object.assign({}, model.get('_session.songLists'));
		for (var songId in songLists) {
			songLists[songId]._storageLocation = 'session';
		}
		return Promise.resolve().then(addAdditionalSharedSongLists);
	}
	else { //stored in DB
		var query = model.query('songLists', {userId: model.get('_session.userId')});
		//fetchGet() is a custom method from derby-promise
		return query.fetchGet().then(function(arrSongLists) {
			songLists = {};
			arrSongLists.forEach(function(list) {
				list._storageLocation = 'db';
				songLists[list.id] = list;
			});
			return arrSongLists;
		})
		.then(addAdditionalSharedSongLists);
	}
	
	//add additional editable song lists shared with the current user that have been opened
	//so far this session
	function addAdditionalSharedSongLists() {
		var lists = localStorage.getItem('sharedSongListsThisSession');
		lists = (lists ? JSON.parse(lists): {});
		//log('additional', lists)
		
		for (var id in lists) {
			lists[id]._storageLocation = 'db';
			songLists[id] = lists[id];
		}
		
		if (asArray) {
			var arrSongLists = [];
			for (var id in songLists) {
				arrSongLists.push(songLists[id]);
			}
			return arrSongLists;
		}
		else return songLists;
	}
};

//Workaround for Firefox
//
// *** IMPORTANT NOTE ***
// It turns out cookies didn't work for this because there's a character limit for cookies,
// so it didn't work for static lists with lots of songs.
// Using localStorage now instead.
//
function saveSongListToCookie(list) {
	var model = app.model;
	
	//Special case: static song list created for entire search result
	//In this case we need to first retrieve the IDs of all matching songs
	if (list._prototype == 'StaticSongList' && list.queryParams) {
		//get an array of IDs of matching songs
		
		var params;
		if (typeof list.queryParams == 'string') {
			params = $.parseJSON(list.queryParams);
		}
		else params = Object.assign({}, list.queryParams);
		delete params.$orderby; //$orderby isn't needed here; we just want the search parameters
		params.$orderby = {id:1};
		var q = model.query('songs', params)
		
		q.fetch(function(err) {
			if (err) return console.error(err);
			var result = q.get();

			//this might be an existing list that already has songs in it
			var existingSongIds = list.songIds;
			var hasExistingSongIds = existingSongIds && existingSongIds.length;

			result.forEach(function(song) {
				if (hasExistingSongIds) {
					//don't add the same song ID twice
					if (existingSongIds.indexOf(song.id) == -1)
						list.songIds.push(song.id);
				}
				else list.songIds.push(song.id);
			});
			delete list.queryParams;

			saveList();
		});
	}
	else {
		saveList();
	}
	
	function saveList() {
		if (!list.name) {
			throw Error("Missing list name.", list);
		}
	
		if (!list.timeCreated) {
			list.timeCreated = Date.now();
		}
	
		var songLists = localStorage.getItem('songLists');
		songLists = (songLists ? $.parseJSON(songLists): {});
		
		songLists[list.name] = list;
		//log('saving list')
		//log(songLists)
		
		localStorage.setItem('songLists', JSON.stringify(songLists));
		//Cookies.set('songLists', JSON.stringify(songLists), {expires: 24*60*60}); //expires in 24 hours
		//we still need to set _session.songLists since that's how the list of existing song lists in the popup window is populated
		model.set('_session.songLists', songLists);
	}
}

//Workaround for Firefox
//
// *** IMPORTANT NOTE ***
// It turns out cookies didn't work for this because there's a character limit for cookies,
// so it didn't work for static lists with lots of songs.
// Using localStorage now instead.
function deleteSongListFromCookie(listId) {
	var model = app.model;
	var songLists = localStorage.getItem('songLists');
	songLists = (songLists ? $.parseJSON(songLists): {});
	
	if (listId in songLists) {
		delete songLists[listId];
	}
	
	localStorage.setItem('songLists', JSON.stringify(songLists));
	//Cookies.set('songLists', JSON.stringify(songLists), {expires: 24*60*60}); //expires in 24 hours
	//we still need to set _session.songLists since that's how the list of existing song lists in the popup window is populated
	//model.set('_session.songLists', songLists);
}

function validateSongListName(listName) {
	if (!listName || !listName.trim()) {
		alert('Please enter a list name');
		return false;
	}

	var model = app.model;
	var existingSongLists = model.get('_page.songListForm.songLists') || [];
	//prevent duplicate names
	var match = false;
	existingSongLists.forEach(function(list) {
		if (listName == list.name) {
			match = true;
			return false;
		}
	});
	if (match) {
		alert('The song list "'+listName+'" already exists; please choose a different name.');
		return false;
	}
	return true;
}

//Printing is being done as a server-only route now
/*
app.fn('songLists.print', function(e, el) {
	window.print();

    //workaround for Chrome bug - https://code.google.com/p/chromium/issues/detail?id=141633
    //see https://stackoverflow.com/questions/18622626/chrome-window-print-print-dialogue-opens-only-after-page-reload-javascript
    if (window.stop) {
        location.reload(); //triggering unload (e.g. reloading the page) makes the print dialog appear
        window.stop(); //immediately stop reloading
    }
});
*/

app.fn('songLists.showRenameForm', function(e, el) {
	var model = this.model;
	model.set('_page.showRenameForm', true);
});

//Rename a song list (the rename option is on the song list view page)
app.fn('songLists.rename', function(e, el) {
	var StaticSongList = require('../../data-objects/SongList/StaticSongList'),
		DynamicSongList = require('../../data-objects/SongList/DynamicSongList');
	var model = this.model;
	
	//security precaution: rename link shouldn't show up without editing permission, but do an extra check here.
	if (!model.get('_page.hasEditPermission')) {
		throw Error('No edit permission for this list');
	}
	
	var listData = model.get('_page.songList');
	
	if (listData.name === model.get('_page.origSongList.name')) {
		alert('The song list name has not changed');
		return;
	}
	
	var list = (listData.isStaticList ? new StaticSongList(): new DynamicSongList());
	Object.assign(list, listData);
	
	saveSongList(list.toJson(), function() {
		alert('Song list renamed successfully.');
		if (model.get('_page.songListStoredInSession')) {
			//log('redirecting to ' + '/song-lists/session/' + list.name)
			window.location = '/song-lists/session/' + list.name;
		}
		else model.set('_page.showRenameForm', false);
	});

	//COMMENTING...this is not working at all on IE for some reason (something to do with restoring the list object or toJson method)
	/*
	//restore SongList object
	//note that this was NOT created using the StaticSongList.fromJson method,
    //we just need to restore its prototype since we're retrieving it from Derby's model

    //NOTE: We can't just do something like songListModel.set('name', newName) because
    //for non-subscribers, lists are stored in the Express session and not in the DB

    var rawList = model.get('_page.songList');

	//TEMP
//    console.log(typeof rawList);
//    for (var i in rawList) {
//        log(i)
//        log(rawList[i])
//    }
//    alert('Error renaming list');
//    return;

	saveSongList(list.toJson(), function() {
		//since non-subscriber lists are saved via AJAX, always reload the page from the server in case
		//there was some error saving the change (so the user sees the problem immediately)
		window.location.reload();
	});
	*/
})

app.fn('songLists.delete', function(e, el) {
	deleteSongList($(el).data('listId'));
});

function deleteSongList(listId, callback) {
	var model = app.model;
	if (determineSongListSaveType(model) == 'session') {
		if (!callback) {
			callback = function() {
				//reload the page
				window.location.reload();
			}
		}
		
		//Firefox workaround
		if (navigator.userAgent.indexOf('Firefox') != -1) {
			deleteSongListFromCookie(listId);
			return callback();
		}
		
		//Save to session instead of database (since free users don't have accounts)
		jQuery.post('/delete-song-list-from-session', {id:listId})
		.done(function() {
			callback();
		})
		.error(function() {
			alert('There was an error deleting this song list. Please try again, or contact us if the error persists.');
		});
	}
	else {
		model.del('songLists.'+listId, function() {
			if (callback) {
				return callback();
			}
			app.history.push('/song-lists');
		})
	}
}

// Email the song list to its creator
app.fn('songLists.sendToCreator', function(e, el) {
	var model = this.model;
	//var listId = model.at(el).get('id');
	var listId = model.get('_page.listIdToShare');

	//listJson needed due to Firefox cookie workaround
	var listJson;
	if (model.get('_page.isFirefox') && determineSongListSaveType(model) == 'session') {
		listJson = JSON.stringify(model.get('_session.songLists.' + listId));
	}
		
	//temp
	//$('#sharing-section').show();
	//showSharingButtons(listName, '123');
	//return;
		
	
	//'http://rest.sharethis.com/v1/share/share?api_key=' + shareThisApiKey
	
	$.post('/send-song-list-to-creator', {
		id: listId,
		listJson: listJson,
		creatorEmail: model.get('_page.creatorEmail')
	})
	.done(function(listDbId) {
		//model.set('_session.songLists.' + listId + '.shared', true);
		
		//Workaround for Firefox - save song lists to cookie in addition to session
		//(issue with sessions over HTTPS)
		if (model.get('_page.isFirefox')) {
			listJson = JSON.parse(listJson);
			listJson._dbId = listDbId;
			saveSongListToCookie(listJson);
		}
		
		showSharingButtons(model.get('_page.listNameToShare'), listDbId);
		model.set('_page.listEmailedToCreator', true);
		
		$('#save-list-form').hide();
		$('#sharing-section').show();
		
		//window.stButtons.locateElements();
		
		//alert('Song list emailed successfully.');
	})
	.error(function() {
		alert('There was an error sharing this song list. Please try again, or contact us if the error persists.');
	});
});

//make accessible from render-fns
app.songLists._showSharingButtons = showSharingButtons;

//show ShareThis buttons
function showSharingButtons(listName, listDbId) {
	var shareUrl = location.protocol+'//'+location.hostname+'/song-lists/' + listDbId;

	$('#sharethis-container').html('');
	var container = $('#sharethis-container')[0];
	
	window.stWidget.addEntry({
		service: 'email',
		element: container,
		url: shareUrl,
		type: 'hcount',
		title: 'A MusicalTheaterSongs.com user shared a song list with you',
		text: 'Email',
		summary: 'A MusicalTheaterSongs.com user shared their song list, "' + listName + '". Click the link above to view it.'
	});
	
	var services = {
		'facebook': 'Facebook',
		'twitter': 'Twitter',
		'pinterest': 'Pinterest',
		'googleplus': 'Google+'
	};
	
	for (var service in services) {
		var label = services[service];
		window.stWidget.addEntry({
			service: service,
			element: container,
			url: shareUrl,
			type: 'hcount',
			text: label
		});
	}
}

//returns whether the song list should be saved in the session or in the DB
function determineSongListSaveType(model, listId) {
	//For subscribed users (except institutional limited accounts), save to the DB
	if (model.get('_session.user.isSubscribed') && model.get('_session.institutionalPlanType') != 'singleLimitedAccount') {
		return 'db';
	}
	else return 'session';
}

app.fn('songLists.deleteSelectedSongs', function(e, el) {
	var StaticSongList = require('../../data-objects/SongList/StaticSongList');
	var model = this.model;

	var $checkedCheckboxes = $('.song-checkbox:checked');
	if (!$checkedCheckboxes.length) {
		alert('You did not select any songs');
		return;
	}
	var msg = 'Are you sure you want to delete the selected song(s) from this list?';
	if (!confirm(msg)) return;

	//restore SongList object
    var list = new StaticSongList(),
        //note that this was NOT created using the StaticSongList.fromJson method,
        //we just need to restore its prototype since we're retrieving it from Derby's model
        rawList = model.get('_page.songList');
    for (var key in rawList) {
        list[key] = rawList[key];
    }

	var selectedSongIds = $checkedCheckboxes.map(function() {
			return $(this).val();
		})
		.get();

    list.removeSongIds(selectedSongIds);

    saveSongList(list.toJson(), function() {
        window.location.reload();
    });
});

app.fn('songLists.addOrEditComments', function(e, el) {
	var model = this.model;
	var songId = e.get(':song.id');
	var selectedSong = model.get('songs.' + songId);
	
	var entry = model.get('_page.commentsBySongId.' + songId)
	if (!entry) {
		//new comment
		entry = {
			songId: songId
		  , comments: null
		};
	}
	else {
		//OLD
		//needed so the cancel button will work correctly
		//(specifically, so it works correctly if the user clicks the edit link again on the same song
		//after canceling an edit)
		//entry = deepCopy(entry);
	}
	model.set('_page.songCommentsForm.comments', entry.comments);
	model.set('_page.commentEntry', entry);
	model.set('_page.selectedSong', selectedSong);

	$('#songCommentsForm').modal('show');
});

app.fn('songLists.addOrEditCommentsFromSongDetailPage', function(e, el) {
	var model = this.model;
	var songId = model.get('_page.song.id');
	var entry = model.get('_page.commentEntry');
	if (!entry) {
		//new comment
        entry = {
            songId: songId
          , comments: null
        };
        model.set('_page.commentEntry', entry);
	}
	model.set('_page.songCommentsForm.comments', entry.comments);

	model.ref('_page.selectedSong.title', '_page.song.title');
	$('#songCommentsForm').modal('show');
});

app.fn('songLists.saveComments', function(e, el) {
	var model = this.model;

	var commentEntry = model.get('_page.commentEntry');
	commentEntry.comments = model.get('_page.songCommentsForm.comments');
	commentEntry.userId = model.get('_session.userId');
	model.set('_page.commentEntry', model.get('_page.commentEntry'));

	var whenDone = function() {
		$('#songCommentsForm').modal('hide');

		//TODO
		//Add an if statement here
		//This is only needed for the song list page, not the song detail page
		//
		//Update the comment column on the song list
		model.set('_page.commentsBySongId.' + commentEntry.songId, commentEntry);
	};
	
	if (commentEntry.id) {
		//existing comment; update it
		//we don't need to fetch first because we already queried songComments
		model.set('songComments.' + commentEntry.id, commentEntry, whenDone);
	}
	else model.add('songComments', commentEntry, whenDone);

//	var commentEntry = {
//		userId: model.get('_session.userId')
//		songId: $('#songComments_songId').val()
//		comments:
//	};
});